import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import CourseGrid from "@/components/courses/CourseGrid";
import Pricing from "@/components/landing/Pricing";
import Affiliate from "@/components/landing/Affiliate";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Features />
      <CourseGrid />
      <Pricing />
      <Affiliate />
      <Footer />
    </div>
  );
};

export default Index;
